var React = require('react');

function TtLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"logo.inline"),React.createElement("text",{"transform":"translate(130.8 67.54) scale(0.97 1)","fontSize":"66","fill":"#fffafa","fontFamily":"Verdana-Bold, Verdana","fontWeight":"700","style":{"isolation":"isolate"},"key":1},"\n    TRUTHTABLE\n  "),React.createElement("rect",{"width":"94","height":"10","fill":"#fffafa","key":2}),React.createElement("polygon",{"points":"52 20 52 117 41 117 41 30 12 30 12 20 52 20","fill":"#fffafa","key":3}),React.createElement("polygon",{"points":"108 20 108 30 75 30 75 96 64 96 64 20 108 20","fill":"#fffafa","key":4})]);
}

TtLogoInline.defaultProps = {"viewBox":"0 0 600.38 117"};

module.exports = TtLogoInline;

TtLogoInline.default = TtLogoInline;
